import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    logo: {
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },
    logoImg: {
      maxHeight: 40,
    },
    app: { borderRadius: 8, overflow: 'hidden' },
    appImg: {
      height: 36,
      display: 'block',
    },
  }
})
